export default __webpack_public_path__ + "static/media/twitter.2bbff426.svg";